<template>
  <main class="sf-page">
    <div v-if="loading" class="sf-loader"><span class="sf-loader__ring"></span></div>
    <div v-else-if="!event" class="sf-section sf-section--cream">
      <div class="sf-container sf-error"><div class="sf-error__icon-wrap"><X /></div><h2 class="sf-h2">Événement introuvable</h2><router-link to="/evenements"><button class="sf-btn sf-btn--terra"><ArrowLeft />Retour</button></router-link></div>
    </div>

    <template v-else>

      <!-- ── Hero ──────────────────────────────────────── -->
      <div class="sev-hero" :style="event.featured_image?`background-image:url('${imageUrl+event.featured_image}')`:''">
        <div class="sev-hero__overlay"></div>
        <div class="sev-hero__content">
          <div class="sf-container">
            <router-link to="/evenements" class="sf-back-link" style="color:rgba(245,239,224,.8);margin-bottom:1.25rem"><ArrowLeft />Retour aux événements</router-link>
            <span class="ev-cat-badge" style="margin-bottom:.85rem;display:inline-block">{{ event.category }}</span>
            <h1 class="sev-hero__title">{{ event.title }}</h1>
            <div class="sev-hero__meta">
              <span class="sf-chip" style="color:rgba(245,239,224,.8)"><Calendar />{{ fmtDateFull(event.start_date) }}</span>
              <span v-if="event.end_date" class="sf-chip" style="color:rgba(245,239,224,.8)"><Clock />Fin : {{ fmtDateFull(event.end_date) }}</span>
              <span class="sf-chip" style="color:rgba(245,239,224,.8)"><MapPin />{{ event.is_online?'En ligne':(event.city||event.location) }}</span>
              <span v-if="event.is_free" style="background:rgba(16,185,129,.2);color:#a7f3d0;font-size:.78rem;padding:.3rem .75rem;border-radius:999px;font-weight:600">Gratuit</span>
              <span v-else style="background:rgba(232,147,58,.2);color:#fde68a;font-size:.78rem;padding:.3rem .75rem;border-radius:999px;font-weight:600">{{ event.registration_fee }} {{ event.fee_currency }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Contenu principal ──────────────────────────── -->
      <section class="sf-section sf-section--cream">
        <div class="sf-container">
          <div class="sev-layout">

            <!-- ── Article ──────────────────────────────── -->
            <article class="sev-article">

              <!-- Description -->
              <div class="sev-prose">{{ event.full_description || event.description }}</div>

              <!-- Galerie -->
              <div v-if="event.gallery_images?.length" style="margin-top:2rem">
                <span class="sf-label">Galerie</span>
                <div class="sf-gallery">
                  <div v-for="(img,i) in event.gallery_images" :key="i" class="sf-gallery-item" style="height:130px" @click="lightbox=i;showLightbox=true">
                    <img :src="imageUrl+img" :alt="`Photo ${i+1}`" loading="lazy" />
                    <div class="sf-gallery-item__overlay"><ZoomIn /></div>
                  </div>
                </div>
              </div>

            </article>

            <!-- ── Sidebar ──────────────────────────────── -->
            <aside class="sev-sidebar">

              <!-- Informations pratiques -->
              <div class="sf-sidebar-card" style="position:sticky;top:80px">
                <div class="sf-sidebar-card__header"><h3>Informations pratiques</h3></div>
                <div class="sf-sidebar-card__body" style="display:flex;flex-direction:column;gap:1rem">

                  <div class="sf-info-row">
                    <div class="sf-info-row__icon"><Calendar /></div>
                    <div><p class="sf-info-row__label">Début</p><p class="sf-info-row__value">{{ fmtDateFull(event.start_date) }}</p></div>
                  </div>
                  <div v-if="event.end_date" class="sf-info-row">
                    <div class="sf-info-row__icon"><Clock /></div>
                    <div><p class="sf-info-row__label">Fin</p><p class="sf-info-row__value">{{ fmtDateFull(event.end_date) }}</p></div>
                  </div>
                  <div class="sf-info-row">
                    <div class="sf-info-row__icon"><MapPin /></div>
                    <div><p class="sf-info-row__label">Lieu</p><p class="sf-info-row__value">{{ event.is_online?'En ligne':((event.location||event.city)||'—') }}</p></div>
                  </div>
                  <div class="sf-info-row">
                    <div class="sf-info-row__icon"><Users /></div>
                    <div>
                      <p class="sf-info-row__label">Participants</p>
                      <p class="sf-info-row__value">{{ event.registered_count||0 }}<span v-if="event.capacity"> / {{ event.capacity }}</span></p>
                      <div v-if="event.capacity" style="margin-top:.4rem"><div class="sf-progress__track"><div class="sf-progress__fill" :style="{width:Math.min(100,(event.registered_count||0)/event.capacity*100)+'%'}"></div></div></div>
                    </div>
                  </div>
                  <div class="sf-info-row">
                    <div class="sf-info-row__icon"><Tag /></div>
                    <div><p class="sf-info-row__label">Type</p><p class="sf-info-row__value">{{ event.event_type==='public'?'Ouvert à tous':event.event_type==='membres'?'Membres uniquement':'Payant' }}</p></div>
                  </div>

                  <!-- CTA Inscription -->
                  <div style="border-top:1px solid var(--ink-12);padding-top:1rem;display:flex;flex-direction:column;gap:.65rem">
                    <button v-if="event.registration_required && event.status==='published'"
                      class="sf-btn sf-btn--terra sf-btn--full"
                      :disabled="event.registered_count>=event.capacity && event.capacity"
                      @click="showRegModal=true">
                      {{ (event.registered_count>=event.capacity && event.capacity) ? 'Complet' : "S'inscrire à l'événement" }}
                    </button>
                    <button v-if="event.donations_enabled" class="sf-btn sf-btn--amber sf-btn--full" @click="showDonateModal=true">
                      <Heart class="sf-btn__icon" />Faire un don pour cet événement
                    </button>
                    <button class="sf-btn sf-btn--outline sf-btn--full sf-btn--sm" @click="share"><Share2 class="sf-btn__icon" />Partager</button>
                  </div>
                </div>
              </div>

              <!-- Objectif de dons -->
              <div v-if="event.donations_enabled && event.donation_goal" class="sf-sidebar-card" style="margin-top:1rem">
                <div class="sf-sidebar-card__header"><h3>Collecte de dons</h3></div>
                <div class="sf-sidebar-card__body">
                  <p style="font-family:var(--fd);font-size:1.5rem;font-weight:700;color:var(--terra)">{{ fmtEur(event.donation_collected) }}</p>
                  <p style="font-size:.78rem;color:var(--ink-60);margin:.25rem 0 .75rem">collectés sur {{ fmtEur(event.donation_goal) }}</p>
                  <div class="sf-progress__track" style="height:8px"><div class="sf-progress__fill" style="background:linear-gradient(90deg,var(--terra),var(--amber))" :style="{width:donationPct+'%'}"></div></div>
                  <p style="font-size:.8rem;color:var(--forest);font-weight:600;margin-top:.5rem">{{ donationPct }}% de l'objectif atteint</p>
                </div>
              </div>

            </aside>
          </div>
        </div>
      </section>

      <!-- Lightbox galerie -->
      <div v-if="showLightbox" class="sf-modal" @click.self="showLightbox=false">
        <button class="sf-modal__close" @click="showLightbox=false"><X /></button>
        <button v-if="lightbox>0" class="sf-modal__nav sf-modal__nav--prev" @click="lightbox--"><ChevronLeft /></button>
        <img :src="imageUrl+event.gallery_images[lightbox]" style="max-height:80vh;object-fit:contain;margin:0 auto;display:block;border-radius:4px" />
        <button v-if="lightbox<event.gallery_images.length-1" class="sf-modal__nav sf-modal__nav--next" @click="lightbox++"><ChevronRight /></button>
        <p class="sf-modal__counter">{{ lightbox+1 }} / {{ event.gallery_images.length }}</p>
      </div>

    </template>

    <!-- ══ MODAL : Inscription ════════════════════════ -->
    <Transition name="modal-fade">
      <div v-if="showRegModal" class="ev-modal-overlay" @click.self="showRegModal=false">
        <div class="ev-modal">
          <div class="ev-modal__head">
            <h3>S'inscrire à cet événement</h3>
            <button @click="showRegModal=false"><X /></button>
          </div>
          <form @submit.prevent="submitRegistration" class="ev-modal__body">
            <div class="ev-reg-recap">
              <span class="sf-chip"><Calendar />{{ fmtDateShort(event?.start_date) }}</span>
              <span class="sf-chip"><MapPin />{{ event?.is_online?'En ligne':event?.city }}</span>
              <span v-if="event?.is_free" class="ev-badge-free">Gratuit</span>
              <span v-else class="ev-badge-paid">{{ event?.registration_fee }} {{ event?.fee_currency }}</span>
            </div>
            <div class="ev-form-grid">
              <div class="ev-field"><label>Prénom <span>*</span></label><input v-model="regForm.first_name" required class="sf-input" /></div>
              <div class="ev-field"><label>Nom <span>*</span></label><input v-model="regForm.last_name" required class="sf-input" /></div>
              <div class="ev-field" style="grid-column:span 2"><label>Email <span>*</span></label><input v-model="regForm.email" required type="email" class="sf-input" /></div>
              <div class="ev-field"><label>Téléphone</label><input v-model="regForm.phone" class="sf-input" placeholder="+237 6…" /></div>
              <div class="ev-field"><label>Organisation</label><input v-model="regForm.organisation" class="sf-input" /></div>
            </div>
            <div v-if="regSuccess" class="ev-success"><CheckCircle />{{ regSuccess }}</div>
            <p v-if="regError" class="ev-error">{{ regError }}</p>
          </form>
          <div class="ev-modal__foot">
            <button class="sf-btn sf-btn--outline" @click="showRegModal=false">Annuler</button>
            <button class="sf-btn sf-btn--terra" :disabled="regLoading" @click="submitRegistration">
              <span v-if="regLoading" class="sf-loader__ring" style="width:16px;height:16px;border-width:2px"></span>
              Confirmer l'inscription
            </button>
          </div>
        </div>
      </div>
    </Transition>

    <!-- ══ MODAL : Don ════════════════════════════════ -->
    <Transition name="modal-fade">
      <div v-if="showDonateModal" class="ev-modal-overlay" @click.self="showDonateModal=false">
        <div class="ev-modal">
          <div class="ev-modal__head"><h3>Soutenir cet événement</h3><button @click="showDonateModal=false"><X /></button></div>
          <div class="ev-modal__body">
            <p style="font-size:.88rem;color:var(--ink-60);line-height:1.65">Votre don soutient directement « {{ event?.title }} » et les actions de Stag Fondation pour l'inclusion numérique à Douala.</p>
            <router-link :to="`/faire-un-don?event=${event?.id}`">
              <button class="sf-btn sf-btn--terra sf-btn--full"><Heart class="sf-btn__icon" />Faire un don pour cet événement</button>
            </router-link>
            <button class="sf-btn sf-btn--outline sf-btn--full" @click="showDonateModal=false">Plus tard</button>
          </div>
        </div>
      </div>
    </Transition>

    <Transition name="toast-fade">
      <div v-if="toast.msg" class="sf-toast"><CheckCircle />{{ toast.msg }}</div>
    </Transition>
  </main>
</template>

<script>
import axios from 'axios'
import AOS from 'aos'; import 'aos/dist/aos.css'
import { ArrowLeft, Calendar, Clock, MapPin, Users, Heart, Share2, ZoomIn, X, Tag,
  ChevronLeft, ChevronRight, CheckCircle } from 'lucide-vue-next'

const PUB = () => axios.create({ baseURL: 'https://api.stagfondation.org/api/public' })

export default {
  name: 'SingleEventPage',
  components: { ArrowLeft, Calendar, Clock, MapPin, Users, Heart, Share2, ZoomIn, X, Tag, ChevronLeft, ChevronRight, CheckCircle },
  data() {
    return {
      imageUrl: 'https://api.stagfondation.org/',
      loading: true, event: null,
      showRegModal:false, showDonateModal:false,
      showLightbox:false, lightbox:0,
      regLoading:false, regError:'', regSuccess:'',
      regForm: { first_name:'', last_name:'', email:'', phone:'', organisation:'' },
      toast: { msg:'', type:'success' }
    }
  },
  computed: {
    donationPct() {
      if(!this.event?.donation_goal) return 0
      return Math.min(100, Math.round((this.event.donation_collected||0)/this.event.donation_goal*100))
    }
  },
  watch: { '$route.params.slug':{handler(s){if(s)this.loadEvent(s)},immediate:true} },
  mounted() { AOS.init({ once:true, offset:70, easing:'ease-out-cubic', duration:650 }) },
  methods: {
    async loadEvent(slug) {
      this.loading=true
      try { const { data } = await PUB().get(`/events/${slug}`); this.event=data.data }
      catch { this.event=null }
      finally { this.loading=false }
    },
    async submitRegistration() {
      this.regLoading=true; this.regError=''; this.regSuccess=''
      try {
        const { data } = await PUB().post(`/events/${this.event.id}/register`, this.regForm)
        this.regSuccess = data.message
        setTimeout(() => { this.showRegModal=false; this.loadEvent(this.$route.params.slug) }, 2000)
      } catch(e) { this.regError = e.response?.data?.message||'Erreur lors de l\'inscription.' }
      finally { this.regLoading=false }
    },
    share() {
      if(navigator.share) navigator.share({ title:this.event.title, url:window.location.href }).catch(()=>{})
      else navigator.clipboard.writeText(window.location.href).then(()=>this.showToast('Lien copié !'))
    },
    fmtDateFull(d) { if(!d)return'—'; return new Date(d).toLocaleDateString('fr-FR',{weekday:'long',day:'numeric',month:'long',year:'numeric',hour:'2-digit',minute:'2-digit'}) },
    fmtDateShort(d) { if(!d)return'—'; return new Date(d).toLocaleDateString('fr-FR',{day:'numeric',month:'short',year:'numeric'}) },
    fmtEur(v) { if(!v)return'0 €'; return Number(v).toLocaleString('fr-FR')+' €' },
    showToast(msg,type='success') { this.toast={msg,type}; setTimeout(()=>{this.toast={msg:'',type:'success'}},3500) }
  }
}
</script>

<style>@import './sf-design.css';</style>
<style scoped>
/* Hero */
.sev-hero { min-height:380px; background:var(--forest) center/cover no-repeat; position:relative; display:flex; align-items:flex-end; }
.sev-hero__overlay { position:absolute; inset:0; background:linear-gradient(to top,rgba(20,18,12,.9) 0%,rgba(20,18,12,.4) 60%,transparent 100%); }
.sev-hero__content { position:relative; z-index:1; width:100%; padding:3rem 0 2.5rem; }
.sev-hero__title { font-family:var(--fd); font-size:clamp(1.8rem,5vw,3.2rem); font-weight:600; color:var(--white); line-height:1.1; max-width:72ch; margin:0 0 1rem; overflow-wrap:break-word; }
.sev-hero__meta { display:flex; flex-wrap:wrap; gap:1.25rem; }

/* Layout */
.sev-layout { display:grid; grid-template-columns:1fr 300px; gap:3rem; align-items:start; }
@media(max-width:900px) { .sev-layout { grid-template-columns:1fr; } .sev-sidebar { order:-1; } }

/* Prose */
.sev-prose { white-space:pre-wrap; font-size:.93rem; color:var(--ink-60); line-height:1.8; overflow-wrap:break-word; word-break:break-word; }

/* Partials from events.vue */
.ev-cat-badge { background:var(--forest); color:var(--cream); font-size:.68rem; letter-spacing:.1em; text-transform:uppercase; padding:.3rem .7rem; border-radius:2px; }
.ev-badge-free { background:rgba(16,185,129,.15); color:#065f46; font-size:.72rem; font-weight:600; padding:.25rem .65rem; border-radius:999px; }
.ev-badge-paid { background:rgba(232,147,58,.15); color:#92400e; font-size:.72rem; font-weight:600; padding:.25rem .65rem; border-radius:999px; }
.ev-modal-overlay { position:fixed; inset:0; background:rgba(0,0,0,.45); display:flex; align-items:center; justify-content:center; z-index:200; padding:1rem; }
.ev-modal { background:var(--white); border-radius:10px; box-shadow:0 20px 60px rgba(0,0,0,.2); max-width:560px; width:100%; max-height:90vh; display:flex; flex-direction:column; }
.ev-modal__head { display:flex; align-items:center; justify-content:space-between; padding:1.25rem 1.5rem; border-bottom:1px solid var(--ink-12); }
.ev-modal__head h3 { font-family:var(--fd); font-size:1.15rem; font-weight:600; color:var(--ink); }
.ev-modal__head button { background:var(--cream); border:none; border-radius:4px; width:28px; height:28px; display:flex; align-items:center; justify-content:center; cursor:pointer; color:var(--ink-60); }
.ev-modal__head button :deep(svg) { width:14px; height:14px; }
.ev-modal__body { padding:1.5rem; overflow-y:auto; flex:1; display:flex; flex-direction:column; gap:1rem; }
.ev-modal__foot { padding:1rem 1.5rem; border-top:1px solid var(--ink-12); display:flex; justify-content:flex-end; gap:.6rem; }
.ev-reg-recap { display:flex; flex-wrap:wrap; gap:.5rem; }
.ev-form-grid { display:grid; grid-template-columns:1fr 1fr; gap:.85rem; }
@media(max-width:480px) { .ev-form-grid { grid-template-columns:1fr; } }
.ev-field { display:flex; flex-direction:column; gap:.3rem; }
.ev-field label { font-size:.8rem; font-weight:500; color:var(--ink); }
.ev-field label span { color:var(--terra); }
.ev-error { font-size:.82rem; color:var(--terra); background:rgba(200,90,42,.07); padding:.65rem 1rem; border-radius:4px; }
.ev-success { display:flex; align-items:center; gap:.5rem; font-size:.85rem; color:#065f46; background:rgba(16,185,129,.1); padding:.75rem 1rem; border-radius:4px; }
.ev-success :deep(svg) { width:18px; height:18px; flex-shrink:0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity .25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.toast-fade-enter-active, .toast-fade-leave-active { transition:opacity .3s ease, transform .3s ease; }
.toast-fade-enter-from, .toast-fade-leave-to { opacity:0; transform:translateY(8px); }
</style>